export default "__VITE_ASSET__e582c527__"